<template>
  <div>
    <div class=" container-fluid   ">
      <div class="llp-container-section  heightcontainer ">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <div id="deals" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
          <!-- Start the code for this screen here -->
          <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white"> <span><b> Edit Quote</b></span></nav>
            <center><span :style="msgcolor"><b>{{ information }}</b></span></center>
            <center><span :style="msgcolor"><b>{{ dateRange }}</b></span></center>
            <center><span :style="msgcolor"><b>{{ quoteMessage }}</b></span></center>
            <br>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Quote Number</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedQuoteNumber"
                  :options="quoteNumbersList" :value="quoteNumbersList" selected="selected" id="customersdd">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="quote" class="col-form-label col-form-label-sm required"> Date Range </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="fromDate" v-validate="'required'" class="form-control input-sm"
                  name="DFrom" data-vv-as="Date Range" />
                <div v-if="errors.has('DFrom')" class="alert-danger"> {{ "Date Range is Mandatory" }} </div>
              </div>
              <!-- <div class="col-sm-6 d-none d-sm-block d-md-none">
              </div> -->
              <div
                class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="toDate" class="form-control input-sm" v-validate="'required'"
                  name="DFrom" data-vv-as="Date Range" />
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Underwriter Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedCreditAnalystId"
                  :options="creditAnalystList" :value="creditAnalystList.employeeId"
                  :custom-label="displayFullName" selected="selected" id="creditAnalyst">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Salesperson Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedAgentId"
                  :options="agentList" :value="agentList.employeeId" :custom-label="displayFullName"
                  selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Dealer Name</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedDealerId"
                  :options="quoteDealersList" :value="quoteDealersList.dealerId" :custom-label="displayDealerFullName"
                  selected="selected" id="customersdd" @input="getDealerDetails(selectedDealerId.dealerId, 'search')">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Lessee Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedCustomerId"
                  :options="quoteCustomersList" :value="quoteCustomersList.customerId"
                  :custom-label="displayCustomerFullName" @input="getFraudLessee(selectedCustomerId.customerId)"
                  selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="searchDealerFraudReason != null">
                  <label class="col-form-label col-form-label-sm">Dealer Fraud Reason</label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="searchDealerFraudReason != null && searchDealerFraudReason != 'Review'">
                  <label v-if="searchDealerFraudReason == ''" style="background-color:Yellow; text-align:center; float:left"
                    class="col-form-label col-form-label-sm">Reason not available</label>
                  <label v-if="searchDealerFraudReason != ''" style="background-color:Red; text-align:center; float:left"
                    class="col-form-label col-form-label-sm">{{searchDealerFraudReason }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="searchDealerFraudReason != null && searchDealerFraudReason == 'Review'">
                  <label style="background-color:Orange;text-align:center; float:left"
                    class="col-form-label col-form-label-sm">{{searchDealerFraudReason }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="searchDealerFraudReason == null">
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="searchDealerFraudReason == null">
                </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                v-if="customerFraudReason != null && customerFraudReason.length">
                <label class="col-form-label col-form-label-sm">Lessee Fraud Reason</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                v-if="customerFraudReason != null && customerFraudReason != 'Review'">
                <label style="background-color:Red; text-align:center; float:left"
                  class="col-form-label col-form-label-sm">{{ customerFraudReason }}</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                v-if="customerFraudReason != null && customerFraudReason == 'Review'">
                <label style="background-color:Orange;text-align:center; float:left"
                  class="col-form-label col-form-label-sm">{{ customerFraudReason }}</label>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Dealer State</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedDealerState"
                  :options="quoteDealerStateList" :value="quoteDealerStateList.stateFipsC"
                  :custom-label="displayStateFullName" selected="selected" id="customersdd">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Year </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="quoteYear" :options="quoteYearList"
                  :value="quoteYearList" selected="selected" id="customersdd">
                </multiselect>
              </div>

            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Make</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="quoteMake" :options="quoteMakeList"
                  :value="quoteMakeList" selected="selected" id="customersdd">
                </multiselect>
              </div>

              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Model</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="quoteModel" :options="quoteModelList"
                  :value="quoteModelList" selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Quote Status </label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <select v-model="quoteStatus" class="form-control input-sm">
                  <option value="All">All</option>
                  <option v-for="(option, index) in status" :value="option.status" :key="index">{{ option.status }}
                  </option>
                </select>
              </div>
            </div>
            <br>
            <center>

              <download-excel class="btn btn-secondary mb-2 mr-3" name="EditQuote.csv" title="Edit Quote"
                worksheet="Edit Quotes" :fetch="getEditQuotesToExport" :fields="edit_quote_fields_export"
                type="csv">Export</download-excel>

              <button type="submit" @click="quotesSearch" class="btn btn-secondary mb-2 mr-3">Search</button>

              <button type="submit" @click="resetEntries" class="btn btn-secondary mb-2 mr-3">Reset</button>

            </center>
            <br>
            <div class="row p-2 justify-content-center">
              <div class="col">
                <div :class="{'table-responsive table-responsive-sm': true, 'hide-scrollbars': isLoading}" style="overflow:auto;">
                  <v-table id="myappsTable" :data="listQuotes" :pageSize="10"
                    @totalPagesChanged="totalPages = $event" class="table table-sm table-bordered table-striped">
                    <thead class="table-month-header-blue wrap-text" slot="head">
                      <v-th sortKey="lmQuoteId">Select</v-th>
                      <v-th sortKey="businessContactFullName">Bussiness Contact Name</v-th>
                      <v-th sortKey="lmProposedLesseeName">Lessee Name</v-th>
                      <v-th sortKey="fraudreason">Customer Fraud Reason</v-th>
                      <v-th sortKey="lmQuote">Quote Generated Date</v-th>
                      <v-th sortKey="lmQuoteId">Quote Number</v-th>
                      <v-th sortKey="lmMake">Make</v-th>
                      <v-th sortKey="lmModel">Model</v-th>
                      <v-th sortKey="lmYear">Year</v-th>
                      <v-th sortKey="lmQuoteStatus">Quote Status</v-th>
                      <v-th sortKey="lmLoanAmount">Loan Amount</v-th>
                      <v-th sortKey="lmDealerName">Dealer Name</v-th>
                      <v-th sortKey="dealerFraudreason">Dealer Fraud Reason</v-th>
                      <v-th sortKey="lmQuoteState">Dealer State</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">

                      <tr v-for="(quote, index) in displayData" :class="colorRow(quote.lmQuoteId)">
                        <td>
                          <input type="radio" v-model="selectedquote"
                            @click="populateQuoteValues(quote.lmQuoteId, index)" v-bind:value="quote.lmQuoteId">
                        </td>
                        <td class="table-month-td">{{ quote.lmProposedLesseeName }}</td>
                        <td class="table-month-td">{{ quote.businessContactFullName }}</td>
                        <td class="table-month-td"
                          v-if="quote.fraudreason != null && quote.fraudreason.length > 0 && quote.fraudreason != 'Review'"
                          style="background-color: Red">{{ quote.fraudreason }} </td>
                        <td class="table-month-td"
                          v-if="quote.fraudreason != null && quote.fraudreason.length > 0 && quote.fraudreason == 'Review'"
                          style="background-color: Orange">{{ quote.fraudreason }} </td>
                        <td class="table-month-td" v-if="quote.fraudreason == null">{{ quote.fraudreason }} </td>
                        <td class="table-month-td">{{ quote.lmQuote | moment("MM/DD/YYYY") }}</td>
                        <td class="table-month-td">{{ quote.lmQuoteId }}</td>
                        <td class="table-month-td">{{ quote.lmMake }}</td>
                        <td class="table-month-td">{{ quote.lmModel }}</td>
                        <td class="table-month-td">{{ quote.lmYear }}</td>
                        <td class="table-month-td">{{ quote.lmQuoteStatus }}</td>
                        <td class="table-month-td">{{ quote.lmLoanAmount }}</td>
                        <td class="table-month-td">{{ quote.lmDealerName }}</td>
                        <td class="table-month-td"
                          v-if="quote.dealerFraudreason != null && quote.dealerFraudreason != 'Review'"
                          style="background-color: Red">{{ quote.dealerFraudreason }} </td>
                        <td class="table-month-td"
                          v-if="quote.dealerFraudreason != null && quote.dealerFraudreason == 'Review'"
                          style="background-color: Orange">{{ quote.dealerFraudreason }} </td>
                        <td class="table-month-td" v-if="quote.dealerFraudreason == null">{{ quote.dealerFraudreason }} </td>
                        <td class="table-month-td">{{ quote.lmQuoteState }}</td>
                      </tr>
                    </tbody>
                  </v-table>
                  <!-- <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages"
                    :style="{ listStyle: 'none' }" /> -->
                <b-pagination v-if="totalPages > 0"  
                      align="right"
                      v-model="currentPage"
                      :total-rows="totalElements"
                      :per-page="perPage"
                      aria-controls="myappsTable"
                      @change="handleClick($event)"
                      :class="{ 'd-none': isLoading || listQuotes.length == 0 }">
                    </b-pagination>
                    <template v-if="listQuotes.length == 0 && !isLoading">
                      <center>
                          <span>
                              <b>No records found</b>
                              <br />
                          </span>
                      </center>
                  </template>
                  <template v-if="isLoading">
                        <div class="d-flex justify-content-center align-items-center">
                          <strong>Loading...</strong>
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                  </template>
                    
                </div>
              </div>
            </div>
            <br>
            <div v-if="quote.lmQuoteId != ''">
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="appDate" class="col-form-label col-form-label-sm"> Quote Date </label>
                </div>
                <div class="col-12 col-md-12 d-flex align-items-center">
                  <label for="appDate" class="col-form-label col-form-label-sm"> {{ quote.lmQuote |
              moment("MM/DD/YYYY") }} </label>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="lesseeName" class="col-form-label col-form-label-sm required"> Lessee Name </label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div>
                    <multiselect style="width:100%" name="proposedLessee" ref="proposedLessee" v-validate="'required'"
                      data-vv-as="Lessee Name" v-model="selectedCustomerData" :options="customersList"
                      :value="customersList.customerId" :custom-label="displayCustomerFullName"
                      @input="getCustomerDetails(selectedCustomerData.customerId)" selected="selected" id="customersdd">
                    </multiselect>
                    <div v-if="errors.has('proposedLessee')" class="alert-danger">{{ errors.first('proposedLessee') }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="quote.LesseeFraudReason != null">
                  <label>Lessee Fraud Reason</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-start align-items-center"
                  v-if="quote.LesseeFraudReason != null && quote.LesseeFraudReason != 'Review'">
                  <label style="background-color:Red; text-align:center;float:left">{{ quote.LesseeFraudReason
                    }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-start align-items-center"
                  v-if="quote.LesseeFraudReason == 'Review'">
                  <label style="background-color:Orange; text-align:center;float:left">{{ quote.LesseeFraudReason
                    }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="salesAgent" class="col-form-label col-form-label-sm required"> Underwriter Name </label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div>
                    <multiselect style="width:100%" name="creditAnalyst" ref="creditAnalyst"
                      data-vv-as="Credit Analyst Name" v-model="selectedCreditAnalystData" :options="creditAnalystList"
                      :value="creditAnalystList.employeeId" :custom-label="displayFullName" v-validate="'required'"
                      @input="getAgentDetails(selectedCreditAnalystData.employeeId, 'CA')" selected="selected"
                      id="creditAnalyst">
                    </multiselect>
                    <div v-if="errors.has('creditAnalyst')" class="alert-danger">{{ errors.first('creditAnalyst') }}</div>
                  </div>
                </div>
                <div v-if="quote.LesseeFraudReason == null"
                  class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="salesAgent" class="col-form-label col-form-label-sm required"> Salesperson Name </label>
                </div>
                <div v-if="quote.LesseeFraudReason == null"
                  class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div>
                    <multiselect style="width:100%" name="proposedLessee" ref="proposedLessee" v-validate="'required'"
                      data-vv-as="Sales Agent" v-model="selectedEmployeeData" :options="agentList"
                      :value="agentList.employeeId" :custom-label="displayFullName"
                      @input="getAgentDetails(selectedEmployeeData.employeeId, 'SR'), updateDealer(selectedEmployeeData.employeeId)"
                      selected="selected" id="customersdd">
                    </multiselect>
                    <div v-if="errors.has('saleagent')" class="alert-danger">{{ errors.first('saleagent') }}</div>
                  </div>
                </div>
              </div>

              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div v-if="quote.LesseeFraudReason != null"
                  class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="salesAgent" class="col-form-label col-form-label-sm required"> Salesperson Name </label>
                </div>
                <div v-if="quote.LesseeFraudReason != null"
                  class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div>
                    <multiselect style="width:100%" name="proposedLessee" ref="proposedLessee" v-validate="'required'"
                      data-vv-as="Sales Agent" v-model="selectedEmployeeData" :options="agentList"
                      :value="agentList.employeeId" :custom-label="displayFullName"
                      @input="getAgentDetails(selectedEmployeeData.employeeId, 'SR'), updateDealer(selectedEmployeeData.employeeId)"
                      selected="selected" id="customersdd">
                    </multiselect>
                    <div v-if="errors.has('saleagent')" class="alert-danger">{{ errors.first('saleagent') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm required"> Source </label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <select name="source" ref="source" v-model.trim="quote.lmSource" class="form-control input-sm"
                      v-validate="'required'" data-vv-as="Source" @change="updateDealer" disabled>
                      <option disabled value=""> Select a Source</option>
                      <option v-for="(option, index) in sources" :value="option.sourceName" :key="index">{{
              option.sourceName }}
                      </option>
                    </select>
                    <div v-if="errors.has('source')" class="alert-danger">{{ errors.first('source') }}</div>
                  </div>
                  <div v-else>
                    <select name="source" ref="source" class="form-control input-sm" v-model.trim="quote.lmSource"
                      v-validate="'required'" data-vv-as="Source" @change="updateDealer" disabled>
                      <option disabled value=""> Select a Source</option>
                      <option v-for="(option, index) in sources" :value="option.sourceName" :key="index">{{
              option.sourceName }}
                      </option>
                    </select>
                    <div v-if="errors.has('source')" class="alert-danger">{{ errors.first('source') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="dealerName" class="col-form-label col-form-label-sm "> Dealer Name </label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <select name="dealerName" v-model.trim="quote.dealerId" @click="getDealerDetails(quote.dealerId, 'quote')"
                      class="form-control input-sm" disabled>
                      <option disabled value=""> Select a Dealer </option>
                      <option v-for="(option, index) in sortedDealers" v-bind:value="option.dealerId"
                        v-bind:key="index">
                        {{
              option.dealerName }} </option>
                    </select>
                  </div>
                  <div v-else>

                    <multiselect style="width:100%" name="dealerName" v-model="selectedDealerData"
                      :options="sortedDealers" :value="sortedDealers.dealerId" label="dealerName"
                      @input="getDealerDetails(selectedDealerData.dealerId, 'quote')" selected="selected" id="customersdd">
                    </multiselect>
                  </div>
                </div>
                <div v-if="quote.LesseeFraudReason == null"
                  class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="leaseType" class="col-form-label col-form-label-sm "> Lease Type </label>
                </div>
                <div v-if="quote.LesseeFraudReason == null"
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <select name="leaseType" v-model.trim="quote.lmLeaseType" class="form-control input-sm" disabled>
                      <option disabled value=""> Select a Lease Type </option>
                      <option v-for="(option, index) in leaseTypes" :value="option.type" :key="index">{{ option.type }}
                      </option>
                    </select>
                  </div>
                  <div v-else>
                    <select name="leaseType" v-model.trim="quote.lmLeaseType" class="form-control input-sm">
                      <option disabled value=""> Select a Lease Type </option>
                      <option v-for="(option, index) in leaseTypes" :value="option.type" :key="index">{{ option.type }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <template v-if="quote.lmSource === 'InHouse'">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                    <label for="InhouseName" class="col-form-label col-form-label-sm"> Inhouse Values</label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <div v-if="quote.lmQuoteStatus == 'Converted'">
                      <select name="InhouseName" v-model.trim="quote.inhouseCategory" class="form-control input-sm"
                        disabled>
                        <option disabled value=""> Select a Inhouse value </option>
                        <option v-for="(option, index) in inhouseList" :value="option.inhouseValue" :key="index">{{
              option.inhouseValue }}</option>
                      </select>
                    </div>
                    <div v-else>
                      <select name="InhouseName" v-model.trim="quote.inhouseCategory" class="form-control input-sm">
                        <option disabled value=""> Select a Inhouse value </option>
                        <option v-for="(option, index) in inhouseList" :value="option.inhouseValue" :key="index">{{
              option.inhouseValue }}</option>
                      </select>
                    </div>
                  </div>
                </template>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="loanamount" class="col-form-label col-form-label-sm"> Loan Amount </label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="loanamount" v-validate="'decimal:2'" class="form-control input-sm"
                      data-vv-as="Loan Amount" v-model.trim="quote.lmLoanAmount" placeholder="Enter Amount"
                      onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                      disabled>
                    <div v-if="errors.has('loanamount')" class="alert-danger">{{ errors.first('loanamount') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="loanamount" v-validate="'decimal:2'" class="form-control input-sm"
                      data-vv-as="Loan Amount" v-model.trim="quote.lmLoanAmount" placeholder="Enter Amount"
                      onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                    <div v-if="errors.has('loanamount')" class="alert-danger">{{ errors.first('loanamount') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="dealerFraudReason != null">
                  <label class="col-form-label col-form-label-sm">Dealer Fraud Reason</label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="dealerFraudReason != null && dealerFraudReason != 'Review'">
                  <label v-if="dealerFraudReason == ''" style="background-color:Yellow; text-align:center; float:left"
                    class="col-form-label col-form-label-sm">Reason not available</label>
                  <label v-if="dealerFraudReason != ''" style="background-color:Red; text-align:center; float:left"
                    class="col-form-label col-form-label-sm">{{dealerFraudReason }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="dealerFraudReason != null && dealerFraudReason == 'Review'">
                  <label style="background-color:Orange;text-align:center; float:left"
                    class="col-form-label col-form-label-sm">{{dealerFraudReason }}</label>
                </div>
                <div v-if="dealerFraudReason == null" class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm"> Terms </label>
                </div>
                <div v-if="dealerFraudReason == null" class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="Text" name="terms" data-vv-as="Terms" class="form-control input-sm"
                      v-validate="'between:2,60'" maxlength="2"
                      onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                      v-model.trim="quote.lmRemainingPayments" disabled />
                    <div v-if="errors.has('terms')" class="alert-danger">{{ errors.first('terms') }}</div>
                  </div>
                  <div v-else>
                    <input type="Text" name="terms" data-vv-as="Terms" class="form-control input-sm"
                      v-validate="'between:2,60'" maxlength="2"
                      onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                      v-model.trim="quote.lmRemainingPayments" />
                    <div v-if="errors.has('terms')" class="alert-danger">{{ errors.first('terms') }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div v-if="quote.LesseeFraudReason != null"
                  class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="leaseType" class="col-form-label col-form-label-sm "> Lease Type </label>
                </div>
                <div v-if="quote.LesseeFraudReason != null"
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <select name="leaseType" v-model.trim="quote.lmLeaseType" class="form-control input-sm" disabled>
                      <option disabled value=""> Select a Lease Type </option>
                      <option v-for="(option, index) in leaseTypes" :value="option.type" :key="index">{{ option.type }}
                      </option>
                    </select>
                  </div>
                  <div v-else>
                    <select name="leaseType" v-model.trim="quote.lmLeaseType" class="form-control input-sm">
                      <option disabled value=""> Select a Lease Type </option>
                      <option v-for="(option, index) in leaseTypes" :value="option.type" :key="index">{{ option.type }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label id="custTypedd" class="col-form-label col-form-label-sm"> Customer type</label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <label for="year"> {{ customerType | formatCustType }} </label>
                </div>
                <div v-if="dealerFraudReason != null"
                  class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm"> Terms </label>
                </div>
                <div v-if="dealerFraudReason != null"
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="Text" name="terms" data-vv-as="Terms" class="form-control input-sm"
                      v-validate="'between:2,60'" maxlength="2"
                      onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                      v-model.trim="quote.lmRemainingPayments" disabled />
                    <div v-if="errors.has('terms')" class="alert-danger">{{ errors.first('terms') }}</div>
                  </div>
                  <div v-else>
                    <input type="Text" name="terms" data-vv-as="Terms" class="form-control input-sm"
                      v-validate="'between:2,60'" maxlength="2"
                      onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                      v-model.trim="quote.lmRemainingPayments" />
                    <div v-if="errors.has('terms')" class="alert-danger">{{ errors.first('terms') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div v-if="quote.lmQuoteId != ''">
              <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Vehicle Information</b></span></nav>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="currentMiles" class="col-form-label col-form-label-sm"> Vin Number </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="Vin Number" v-validate="'min:6'" class="form-control input-sm"
                      data-vv-as="Vin Number" v-model.trim="quote.lmVin" placeholder="Enter Min Last 6 characters"
                      disabled>
                    <div v-if="errors.has('Vin Number')" class="alert-danger">{{ errors.first('Vin Number') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="Vin Number" v-validate="'min:6'" class="form-control input-sm"
                      data-vv-as="Vin Number" v-model.trim="quote.lmVin" placeholder="Enter Min Last 6 characters"
                      @input="getVinFraudReason(quote.lmVin)">
                    <div v-if="errors.has('Vin Number')" class="alert-danger">{{ errors.first('Vin Number') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="this.quote.lmVin != '' && this.quote.vinFraudReason != null">
                  <label for="currentMiles" class="col-form-label col-form-label-sm"> Vin Fraud Reason </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="this.quote.lmVin != '' && this.quote.vinFraudReason != null">
                  <label for="currentMiles" class="col-form-label col-form-label-sm"
                    style="background-color:Red; text-align:center;float:left"> {{ quote.vinFraudReason }} </label>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="make" class="col-form-label col-form-label-sm"> Make </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" v-validate="'max:150'" class="form-control input-sm" data-vv-as="Make"
                      name="make" v-model.trim="quote.lmMake" placeholder="Enter Make" disabled>
                    <div v-if="errors.has('make')" class="alert-danger">{{ errors.first('make') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" v-validate="'max:150'" class="form-control input-sm" data-vv-as="Make"
                      name="make" v-model.trim="quote.lmMake" placeholder="Enter Make">
                    <div v-if="errors.has('make')" class="alert-danger">{{ errors.first('make') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="model" class="col-form-label col-form-label-sm"> Model </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="model" class="form-control input-sm" v-validate="'max:150'"
                      data-vv-as="Model" v-model.trim="quote.lmModel" placeholder="Enter Model" disabled>
                    <div v-if="errors.has('model')" class="alert-danger">{{ errors.first('model') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" class="form-control input-sm" name="model" v-validate="'max:150'"
                      data-vv-as="Model" v-model.trim="quote.lmModel" placeholder="Enter Model">
                    <div v-if="errors.has('model')" class="alert-danger">{{ errors.first('model') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="year" class="col-form-label col-form-label-sm"> Year </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="year" v-validate="'digits:4'" class="form-control input-sm"
                      data-vv-as="Year" v-model.trim="quote.lmYear" placeholder="Enter Year" maxlength="4"
                      onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                      disabled>
                    <div v-if="errors.has('year')" class="alert-danger">{{ errors.first('year') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="year" v-validate="'digits:4'" class="form-control input-sm"
                      data-vv-as="Year" v-model.trim="quote.lmYear" placeholder="Enter Year" maxlength="4"
                      onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                    <div v-if="errors.has('year')" class="alert-danger">{{ errors.first('year') }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="currentMiles" class="col-form-label col-form-label-sm"> Current Miles </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="currentMiles" v-validate="'numeric'" class="form-control input-sm"
                      data-vv-as="Current Miles" v-model.trim="quote.lmMiles" placeholder="Enter Miles" disabled>
                    <div v-if="errors.has('currentMiles')" class="alert-danger">{{ errors.first('currentMiles') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="currentMiles" v-validate="'numeric'" class="form-control input-sm"
                      data-vv-as="Current Miles" v-model.trim="quote.lmMiles" placeholder="Enter Miles">
                    <div v-if="errors.has('currentMiles')" class="alert-danger">{{ errors.first('currentMiles') }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12 d-flex justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="this.quote.LesseeFraudReason != 'Review' && (this.quote.overrideFraud != null || this.continue == 'Approval' || this.vincontinue == 'Approval')">
                  <label for="currentMiles" class="col-form-label col-form-label-sm required"> Fraud Managers
                    Approval</label>
                </div>
                <div
                  class="col-12 col-lg-4 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="this.quote.LesseeFraudReason != 'Review' && (this.quote.overrideFraud != null || this.continue == 'Approval' || this.vincontinue == 'Approval')">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="Approval Note" v-validate="'required'" class="form-control input-sm"
                      @input="enableSubmit()" data-vv-as="Approval Note"
                      placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman" v-model.trim="quote.overrideFraud"
                      disabled>
                    <div v-if="errors.has('Approval Note')" class="alert-danger">{{ errors.first('Approval Note') }}
                    </div>
                  </div>
                  <div v-else>
                    <input type="text" name="Approval Note" v-validate="'required'" class="form-control input-sm"
                      @input="enableSubmit()" placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman"
                      data-vv-as="Approval Note" v-model.trim="quote.overrideFraud">
                    <div v-if="errors.has('Approval Note')" class="alert-danger">{{ errors.first('Approval Note') }}
                    </div>
                  </div>
                </div>

              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="this.quote.LesseeFraudReason == 'Review' && (this.quote.overrideFraud != null || this.continue == 'Approval' || this.vincontinue == 'Approval')">
                  <label for="currentMiles" class="col-form-label col-form-label-sm"> Fraud Managers Approval</label>
                </div>
                <div
                  class="col-12 col-lg-4 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="this.quote.LesseeFraudReason == 'Review' && (this.quote.overrideFraud != null || this.continue == 'Approval' || this.vincontinue == 'Approval')">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="Approval Note" class="form-control input-sm" @input="enableSubmit()"
                      data-vv-as="Approval Note" placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman"
                      v-model.trim="quote.overrideFraud" disabled>
                  </div>
                  <div v-else>
                    <input type="text" name="Approval Note" class="form-control input-sm" @input="enableSubmit()"
                      placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman" data-vv-as="Approval Note"
                      v-model.trim="quote.overrideFraud">
                  </div>
                </div>

              </div>
              <div id="myModal" class="modal">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2>Fraud Alert</h2>
                  </div>
                  <div class="modal-body">
                    There is fraud block. To continue, override provide supervisor
                  </div>
                  <br>
                  <div class="modal-footer"><button class="btn-blue-save submitButton"
                      @click="fraudoverride()">OK</button>
                  </div>
                </div>
              </div>
              <div id="reviewAlert" class="modal">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2>Review Alert</h2>
                  </div>
                  <div class="modal-body">
                    There is fraud block. To continue, override provide supervisor
                  </div>
                  <br>
                  <div class="modal-footer"><button class="btn-blue-save nextButton"
                      @click="fraudoverride()">OK</button>
                  </div>
                </div>
              </div>
              <div id="vinDecoder" class="modal">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2>No Vehicle Found</h2>
                  </div>
                  <div class="modal-body">
                    {{ vehicleInfoMessage }}
                  </div>
                  <br>
                  <div class="modal-footer"><button class="btn-blue-save nextButton" @click="clearVIN()">OK</button>
                  </div>
                </div>
              </div>
              <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Customer Details</b></span></nav>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 " v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="addressLine1" class="col-form-label col-form-label-sm"> Address Line1 </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="addressLine1" class="form-control input-sm" v-validate="'max:50'"
                      data-vv-as="Address Line 1" v-model.trim="customer.address.street1"
                      placeholder="Enter Address Line1" disabled>
                    <div v-if="errors.has('addressLine1')" class="alert-danger">{{ errors.first('addressLine1') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="addressLine1" class="form-control input-sm" v-validate="'max:50'"
                      data-vv-as="Address Line 1" v-model.trim="customer.address.street1"
                      placeholder="Enter Address Line1">
                    <div v-if="errors.has('addressLine1')" class="alert-danger">{{ errors.first('addressLine1') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="addressLine2" class="col-form-label col-form-label-sm"> Address Line2 </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="addressLine2" class="form-control input-sm" v-validate="'max:50'"
                      data-vv-as="Address Line 2" v-model.trim="customer.address.street2"
                      placeholder="Enter Address Line2" disabled>
                    <div v-if="errors.has('addressLine2')" class="alert-danger">{{ errors.first('addressLine2') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="addressLine2" class="form-control input-sm" v-validate="'max:50'"
                      data-vv-as="Address Line 2" v-model.trim="customer.address.street2"
                      placeholder="Enter Address Line2">
                    <div v-if="errors.has('addressLine2')" class="alert-danger">{{ errors.first('addressLine2') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="city" class="col-form-label col-form-label-sm"> City </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="city" v-validate="'max:50'" class="form-control input-sm" data-vv-as="City"
                      v-model.trim="customer.address.city" placeholder="Enter City" disabled>
                    <div v-if="errors.has('city')" class="alert-danger">{{ errors.first('city') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="city" v-validate="'max:50'" class="form-control input-sm" data-vv-as="City"
                      v-model.trim="customer.address.city" placeholder="Enter City">
                    <div v-if="errors.has('city')" class="alert-danger">{{ errors.first('city') }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 " v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="stateCode" class="col-form-label col-form-label-sm"> State </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <select name="stateCode" v-model.trim="customer.address.stateFipsC" class="form-control input-sm"
                      disabled>
                      <option disabled value=""> Select a State </option>
                      <option v-for="state in states" v-bind:value="state.stateFipsC" v-bind:key="state.stateFipsC">
                        {{ state.stateN }}
                      </option>
                    </select>
                  </div>
                  <div v-else>
                    <multiselect style="width:100%" name="proposedLessee" v-model="selectedCustomerStateData"
                      :options="states" :value="states.stateFipsC" label="stateN"
                      @input="getCustomerStateDetails(selectedCustomerStateData.stateFipsC)" selected="selected"
                      id="customersdd">
                    </multiselect>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="country" class="col-form-label col-form-label-sm"> Country </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" data-vv-as="Country" class="form-control input-sm" v-validate="'max:40'"
                      name="country" v-model.trim="customer.address.country" disabled>
                    <div v-if="errors.has('country')" class="alert-danger">{{ errors.first('country') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" class="form-control input-sm" data-vv-as="Country" v-validate="'max:40'"
                      name="country" v-model.trim="customer.address.country" disabled>
                    <div v-if="errors.has('country')" class="alert-danger">{{ errors.first('country') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="zip" class="col-form-label col-form-label-sm"> Zip Code </label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="zip" data-vv-as="Zip Code" class="form-control input-sm" maxlength="5"
                      v-validate="{ regex: /^(\d)(?!\1+$)/, digits: 5 }" v-model.trim="customer.address.zipCode"
                      placeholder="Enter 5 Digit zip" disabled>
                    <div v-if="errors.has('zip')" class="alert-danger">{{ errors.first('zip') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="zip" data-vv-as="Zip Code" class="form-control input-sm" maxlength="5"
                      v-validate="{ regex: /^(\d)(?!\1+$)/, digits: 5 }" v-model.trim="customer.address.zipCode"
                      @input="zipDecoder" placeholder="Enter 5 Digit zip">
                    <div v-if="errors.has('zip')" class="alert-danger">{{ errors.first('zip') }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 " v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="email" class="col-form-label col-form-label-sm"> Email </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="email" v-validate="'email'" class="form-control input-sm"
                      data-vv-as="Email" v-model.trim="customer.digitalContactInfo.email" placeholder="Enter EmailID"
                      maxlength="50" disabled>
                    <div v-if="errors.has('email')" class="alert-danger">{{ errors.first('email') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="email" class="form-control input-sm" v-validate="'email'"
                      data-vv-as="Email" v-model.trim="customer.digitalContactInfo.email" placeholder="Enter EmailID"
                      maxlength="50">
                    <div v-if="errors.has('email')" class="alert-danger">{{ errors.first('email') }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 " v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="workNumber" class="col-form-label col-form-label-sm"> Work Number </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="workNumber" class="form-control input-sm" v-validate="'min:10|max:15'"
                      data-vv-as="Work Number" v-model.trim="customer.digitalContactInfo.workNumber"
                      @input="formatWorkPhoneNumber" @blur="formatWorkPhoneNumber" placeholder="Enter Work Number"
                      disabled>
                    <div v-if="errors.has('workNumber')" class="alert-danger">{{ errors.first('workNumber') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="workNumber" v-validate="'min:10|max:15'" class="form-control input-sm"
                      data-vv-as="Work Number" v-model.trim="customer.digitalContactInfo.workNumber"
                      @input="formatWorkPhoneNumber" @blur="formatWorkPhoneNumber" placeholder="Enter Work Number">
                    <div v-if="errors.has('workNumber')" class="alert-danger">{{ errors.first('workNumber') }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="mobileNumber" class="col-form-label col-form-label-sm"> Mobile Number </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <div v-if="quote.lmQuoteStatus == 'Converted'">
                    <input type="text" name="mobileNumber" class="form-control input-sm" v-validate="'min:10|max:15'"
                      data-vv-as="Mobile Number" v-model.trim="customer.digitalContactInfo.mobileNumber"
                      @input="formatCellPhoneNumber" @blur="formatCellPhoneNumber" placeholder="Enter Mobile Number"
                      disabled>
                    <div v-if="errors.has('mobileNumber')" class="alert-danger">{{ errors.first('mobileNumber') }}</div>
                  </div>
                  <div v-else>
                    <input type="text" name="mobileNumber" class="form-control input-sm" v-validate="'min:10|max:15'"
                      data-vv-as="Mobile Number" v-model.trim="customer.digitalContactInfo.mobileNumber"
                      @input="formatCellPhoneNumber" @blur="formatCellPhoneNumber" placeholder="Enter Mobile Number">
                    <div v-if="errors.has('mobileNumber')" class="alert-danger">{{ errors.first('mobileNumber') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div v-if="quote.lmQuoteId!=''">
              <!--	<div v-if="quote.lmQuoteStatus == 'Converted'">
						<div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center mb-3">
							<div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
								<button type="submit" value="search" class="btn btn-secondary" @click="savequotedata" disabled>Submit</button>
							</div>
						</div>
					</div>-->
              <div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center mb-3">
                  <div class="center">
                    <button type="submit" class="btn btn-secondary" @click="savequotedata">Submit</button>
                  </div>
                </div>
              </div>
              <br><br>
            </div>
          </div>
          <!-- End of the code for this screen here -->
          <bottom-footer></bottom-footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import httpcommon from '../js/http-common.js'
import httpcustomer from '../js/http-customer.js'
import httpsource from '../js/http-managesource.js'
import httpdeal from '../js/http-dealstracking.js'
import httpemployee from '../js/http-employee.js'
import quotesjson from '../json/quotes.json'
import util from '../js/common-utils'
import moment from 'moment'

import MainMenu from '@/components/Menu.vue'
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'editQuote',
  data () {
    return {
      vehicleInfoMessage: '',
      quoteIdList: [],
      quote: this.initializedata(), // intialize quote entry fields
      states: [],
      selectedCustomerData: '',
      selectedEmployeeData: '',
      selectedCreditAnalystData: '',
      selectedDealerData: '',
      selectedCustomerStateData: '',
      currentPage: 1,
      totalPages: 0,
      perPage: 10,
      numberOfElements: 0,
      totalElements: 0,
      vincontinue: null,
      selectedDealerId: '',
      selectedEmployeeId: '',
      selectedCustomerId: '',
      selectedDealerState: '',
      quoteDealersList: [],
      quoteYearList: [],
      quoteMakeList: [],
      quoteModelList: [],
      quoteCustomersList: [],
      quoteDealerStateList: [],
      quoteNumbersList: [],
      quoteAgentsList: [],
      quoteCreditAnalystList: [],
      selectedAgentId: '',
      selectedCreditAnalystId: '',
      selectedQuoteNumber: '',
      enablebutton: true,
      enablesubmitbtn: true,
      LesseeFraudReason: null,
      quoteYear: '',
      quoteMake: '',
      quoteModel: '',
      continue: null,
      quoteStatus: '',
      customer: null,
      listQuotes: [],
      isLoading: false,
      fromDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      information: '',
      customerFraudReason: null,
      dealerFraudReason: null,
      searchDealerFraudReason: null,
      quoteMessage: '',
      quoteSearch: '',
      msgcolor: {
        color: 'black'
      },
      leaseTypes: [
        { type: 'Sale' },
        { type: 'LeaseBack' },
        { type: 'Prime Lease' },
        { type: 'Finance' }
      ],
      customersList: [],
      agentList: [],
      creditAnalystList: [],
      dealersList: [],
      sources: [
        { sourceName: 'Dealer' },
        { sourceName: 'InHouse' }
      ],
      status: [
        { status: 'Open' },
        { status: 'Converted' }
      ],

      selectedquote: '',
      inhouseList: [
        { inhouseValue: 'Dupont Registry' },
        { inhouseValue: 'Sports Car Markett' },
        { inhouseValue: 'Google' },
        { inhouseValue: 'Instagram' },
        { inhouseValue: 'Facebook' },
        { inhouseValue: 'Existing Customer' },
        { inhouseValue: 'Other' }
      ],

      heads: [
        { name: 'Select' },
        { name: 'Lessee Name' },
        { name: 'Bussiness Contact Name' },
        { name: 'Customer Fraud Reason' },
        { name: 'Quote Generated Date' },
        { name: 'Quote Number' },
        { name: 'Make' },
        { name: 'Model' },
        { name: 'Year' },
        { name: 'Status' },
        { name: 'Loan Amount' },
        { name: 'Dealer Name' },
        { name: 'Dealer State' }
      ],
      edit_quote_fields_export: {
        'Lessee Name': 'lmProposedLesseeName',
        'Business Contact Name': 'businessContactFullName',
        'Quote Date': 'lmQuote',
        'Quote Number': 'lmQuoteId',
        'Make': 'lmMake',
        'Model': 'lmModel',
        'Year': 'lmYear',
        'Loan Amount': 'lmLoanAmount',
        'Dealer Name': 'lmDealerName',
        'Source': 'lmSource',
        // 'Dealer State': '',
        'Quote Status': 'lmQuoteStatus',
        'Dealer State': 'lmQuoteState'
      },
      fraudMobileError: ''
    }
  },
  methods: {
    zipDecoder () {
      if (this.customer.address.zipCode.length == 5) {
        httpcommon.get('/statefip/zipCode/' + this.customer.address.zipCode)
          .then(response => {
            if (response.data.city != null) {
              this.customer.address.city = response.data.city
            } else {
              this.customer.address.city = ''
            }
            if (response.data.city != null) {
              this.getCustomerStateDataDetails(response.data.state)
            } else {
              this.selectedCustomerStateData = ''
            }
          })

          .catch(e => { this.errorslist.push(e) })
      }
    },
    getCustomerStateDataDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          this.selectedCustomerStateData = this.states[i]
        }
      }
    },
    getVehicleInfo (vin) {
      httpdeal.get('/quote/getVechicleInfo/' + vin).then(response => {
        if (response.data[0].year == null && response.data[0].make == null && response.data[0].model == null && response.data[0].trim == null) {
          httpdeal.get('/quote/getVechicleInfoMessage').then(response => {
            this.vehicleInfoMessage = response.data
          })
          var modal = document.getElementById('vinDecoder')
          modal.style.display = 'block'
          this.quote.lmMake = ''
          this.quote.lmModel = ''
          this.quote.lmYear = ''
        } else {
          this.quote.lmYear = response.data[0].year
          this.quote.lmMake = response.data[0].make
          this.quote.lmModel = response.data[0].model
        }
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    clearVIN () {
      var modal = document.getElementById('vinDecoder')
      modal.style.display = 'none'
      this.vehicleInfoMessage = ''
    },

    displayCustomerFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    displayFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    displayDealerFullName (option) {
      return `${option.dealerName}`
    },
    displayStateFullName (option) {
      return `${option.stateN}`
    },

    // Get Edit Quotes for Export
    async getEditQuotesToExport (page = 0) {
      if (this.quoteStatus == 'All') {
        this.quoteStatus = ''
      }
      const payload = {
        "quoteNumber": this.selectedQuoteNumber || "",
        "fromDate": this.fromDate || null,
        "toDate": this.toDate || null,
        // "fromDate": "2024-11-10",
        // "toDate": "2024-11-19",
        "salesRepId": this.selectedAgentId.employeeId || null,
        "dealerId": this.selectedDealerId.dealerId || null,
        "customerId": this.selectedCustomerId.customerId || null,
        "dealerState": this.selectedDealerState.stateFipsC || "",
        "make": this.quoteMake || "",
        "year": this.quoteYear || null,
        "model": this.quoteModel || "",
        "quoteStatus": this.quoteStatus || "",
        "creditAnalystId": this.selectedCreditAnalystId.employeeId || null
        }
      const response = await httpdeal.post('/quote/SearchQuote', payload, {params: {'page' : page, 'size': 20}})
      if (this.quoteStatus == '') {
        this.quoteStatus = 'All'
      }
      return response.data.content
    },

    handleClick (event) {
      this.currentPage = event
      this.quotesSearch()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#deals').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },

    retriveQuoteNumbersList () {
      httpdeal.get('/quote/quoteNumber').then(response => {
        this.quoteNumbersList = response.data
      })
    },
    retrieveQuoteCustomerList () {
      httpdeal.get('/quote/quotecustomers').then(response => {
        this.quoteCustomersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    // retriveQuoteEmployeeList () {
    //   httpdeal.get('/quote/quoteemployees').then(response => {
    //     if (response.data.length > 0) {
    //       this.quoteAgentsList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'SR'
    //       })
    //       this.quoteCreditAnalystList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'CA'
    //       })
    //     }
    //   })
    // },

    getFraudCustomer (customerId) {
      this.quote.LesseeFraudReason = null
      httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + parseInt(customerId)).then(response => {
        if (response.data.length > 0) {
          if (response.data[0].customerFraudReason != null && response.data[0].customerFraudReason !== '') {
            this.quote.LesseeFraudReason = response.data[0].customerFraudReason
            if (this.quote.LesseeFraudReason != null && this.quote.overrideFraud == null || this.quote.overrideFraud.length < 0 && this.quote.lmQuoteStatus != 'Converted') {
              if (this.quote.LesseeFraudReason != 'Review') {
                var modal = document.getElementById('myModal')
                modal.style.display = 'block'
                this.enablebutton = true
                this.enablesubmitbtn = true
              } else {
                modal = document.getElementById('reviewAlert')
                modal.style.display = 'block'
                this.enablebutton = true
                this.enablesubmitbtn = true
              }
            } else if (this.quote.LesseeFraudReason != null) {
              this.continue = 'Approval'
              if (this.quote.overrideFraud != null) {
                this.enablebutton = false
                this.enablesubmitbtn = false
              }
            } else {
              this.enablebutton = false
              this.enablesubmitbtn = false
            }
          } else {
            this.quote.LesseeFraudReason = null
          }
        } else {
          this.quote.LesseeFraudReason = null
          if (this.quote.vinFraudReason == null && this.quote.vinFraudReason != undefined) {
            this.quote.overrideFraud = null
          }
          this.continue = null
          this.enablebutton = false
          this.enablesubmitbtn = false
        }
      })
    },

    getFraudLessee (customerId) {
      this.customerFraudReason = null
      httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + parseInt(customerId)).then(response => {
        if (response.data.length > 0) {
          if (response.data[0].customerFraudReason != null) {
            this.customerFraudReason = response.data[0].customerFraudReason
            this.quote.LesseeFraudReason = response.data[0].customerFraudReason
          }
        } else {
          this.customerFraudReason = null
          this.quote.LesseeFraudReason = null
        }
      })
    },

    getVinFraudReason (vin) {
      if (vin != null && vin.length > 0) {
        if (this.quote.lmVin.length >= 6) {
          this.getVehicleInfo(this.quote.lmVin)
          httpcustomer.get('customer/getVinFraudDetails?vin=' + vin).then(response => {
            if (response.data.length == 0 || response.data[0].vinFraudReason == null) {
              this.vincontinue = null
              this.enablebutton = false
              this.enablesubmitbtn = false
            }
            if (response.data.length != 0 && response.data[0].vinFraudReason != null) {
              if (response.data[0].vinFraudReason.length != 0) {
                this.quote.vinFraudReason = response.data[0].vinFraudReason
                if (this.quote.vinFraudReason != null && this.quote.lmQuoteStatus != 'Converted' && this.quote.overrideFraud == null) {
                  var modal = document.getElementById('myModal')
                  modal.style.display = 'block'
                  this.vincontinue = 'Approval'
                } else if (this.quote.overrideFraud != null && this.quote.vinFraudReason != null && this.quote.lmQuoteStatus != 'Converted') {
                  if (this.quote.overrideFraud.length == 0 && this.quote.lmQuoteStatus != 'Converted') {
                    modal = document.getElementById('myModal')
                    modal.style.display = 'block'
                    this.vincontinue = 'Approval'
                  }
                }
                if (this.quote.overrideFraud != null && this.quote.vinFraudReason != null && this.quote.lmQuoteStatus != 'Converted') {
                  this.vincontinue = 'Approval'
                  this.enablebutton = false
                  this.enablesubmitbtn = false
                }
              } else {
                this.vincontinue = null
                this.enablebutton = false
                this.enablesubmitbtn = false
              }
            }
          })
            .catch(e => {
              console.log(e)
              this.errors.push(e)
            })
        }
      } else {
        this.quote.vinFraudReason = null
        if (this.quote.vinFraudReason == null && this.quote.LesseeFraudReason == null && this.quote.LesseeFraudReason != undefined) {
          this.quote.overrideFraud = null
        }

        this.enablebutton = false
        this.enablesubmitbtn = false
        this.vincontinue = null
      }
    },
    fraudoverride () {
      if (this.quote.LesseeFraudReason != null) {
        if (this.quote.LesseeFraudReason != 'Review') {
          this.continue = 'Approval'
          var modal = document.getElementById('myModal')
          modal.style.display = 'none'
          this.enablebutton = true
          this.enablesubmitbtn = true
        } else {
          this.continue = 'Approval'
          modal = document.getElementById('reviewAlert')
          modal.style.display = 'none'
          this.enablebutton = false
          this.enablesubmitbtn = false
        }
      }
      if (this.quote.vinFraudReason != null) {
        this.vincontinue = 'Approval'
        modal = document.getElementById('myModal')
        modal.style.display = 'none'
        this.enablebutton = true
        this.enablesubmitbtn = true
      }
    },
    fraudoverridecancel () {
      var modal = document.getElementById('myModal')
      modal.style.display = 'none'
      this.enablebutton = true
      this.enablesubmitbtn = true
    },

    retriveQuoteYearList () {
      httpdeal.get('/quote/quoteyears').then(response => {
        this.quoteYearList = response.data
      })
    },
    retriveQuoteMakeList () {
      httpdeal.get('/quote/quotemake').then(response => {
        this.quoteMakeList = response.data
      })
    },
    retriveQuoteModelList () {
      httpdeal.get('/quote/quotemodel').then(response => {
        this.quoteModelList = response.data
      })
    },
    retriveQuoteDealerStateList () {
      httpdeal.get('/quote/quotedealerstate').then(response => {
        this.quoteDealerStateList = response.data
      })
    },
    retrieveQuoteDealerList () {
      httpdeal.get('/quote/quotedealers').then(response => {
        this.quoteDealersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errorlist.push(e)
        })
    },

    formatCellPhoneNumber: function (event) {
      var phone = this.customer.digitalContactInfo.mobileNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.digitalContactInfo.mobileNumber = phone
      this.getCustomerMobileFraud()
    },
    formatWorkPhoneNumber: function (event) {
      var phone = this.customer.digitalContactInfo.workNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.digitalContactInfo.workNumber = phone
    },

    getCustomerDetails (customerId) {
      if (customerId >= 0) {
        httpcustomer.get('/customer/' + customerId).then(response => {
          var customerlist = response.data
          var customerobject = customerlist[0]
          this.selectedCustomerData = customerlist[0]
          if (customerobject.customerId === customerId) {
            this.customer = customerobject
            this.getCustomerStateDetails(this.customer.address.stateFipsC)

            this.customer.digitalContactInfo.mobileNumber = customerobject.digitalContactInfo.mobileNumber.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
            this.customer.digitalContactInfo.workNumber = customerobject.digitalContactInfo.workNumber.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
            // this.getCustomerMobileFraud()
          }
          // this.getFraudLessee(customerId)
          this.getFraudCustomer(customerId)
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    getAgentDetails (employeeId, role) {
      if (employeeId >= 0) {
        httpemployee.get('/employee/' + employeeId).then(response => {
          var employeelist = response.data
          if (role === 'SR') {
            this.selectedEmployeeData = employeelist[0]
          }
          if (role === 'CA') {
            this.selectedCreditAnalystData = employeelist[0]
          }
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getDealerDetails (dealerId, field) {
      if (dealerId >= 0) {
        httpsource.get('/dealerbyid/' + dealerId).then(response => {
          var dealerlist = response.data
          this.selectedDealerData = dealerlist
          if (dealerlist.fraudInd === 'Y') {
            if (field === 'quote') {
              this.dealerFraudReason = dealerlist.redFlagReason
            }
            if (field === 'search') {
              this.searchDealerFraudReason = dealerlist.redFlagReason
            }
          } else {
            if (field === 'quote') {
              this.dealerFraudReason = null
            }
            if (field === 'search') {
              this.searchDealerFraudReason = null
            }
          }
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getCustomerStateDetails (stateFipsC) {
      if (stateFipsC >= 0) {
        httpcommon.get('/statefip/' + stateFipsC).then(response => {
          var customerstatelist = response.data
          this.selectedCustomerStateData = customerstatelist[0]
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    },
    getCustomerMobileFraud () {
      if (this.customer.digitalContactInfo.mobileNumber != '') {
        httpcustomer.get('/customer/checkfraudMobileNumber/' + this.customer.digitalContactInfo.mobileNumber.replace(/[^0-9]/g, '')).then(response => {
          if (response.data == 'Y') {
            this.fraudMobileError = 'The given MobileNumber is blocked'
          } else {
            this.fraudMobileError = ''
          }
        })
      }
    },
    retrieveAgentList () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        if (response.data.length > 0) {
          // this.agentList = response.data.filter((employee) => {
          //   return employee.userRoleC !== 'CA'
          // })
          this.agentList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'SR');
          })
          // this.creditAnalystList = response.data.filter((employee) => {
          //   return employee.userRoleC === 'CA'
          // })
          this.creditAnalystList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'CA');
          })
        }
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveCustomerList () {
      httpcustomer.get('/customer/').then(response => {
        this.customersList = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    updateDealer (employeeId) {
      console.log('dealer list')
      this.dealersList = []
      if (this.quote.lmSource == 'InHouse') {
        console.log('dl0')
        httpsource.get('/dealersearch').then(response => {
          if (response.data.length != 0) {
            console.log('dl1')
            // this.dealersList = []
            this.dealersList = response.data
          }
        })
          .catch(error => {
            console.log('Failed to load dealers:' + error)
          })
      } else if (employeeId != undefined) {
        console.log('dl2')
        httpemployee.get('/employee/' + parseInt(employeeId)).then(response => {
          this.dealersList = []
          console.log('dl3')
          for (var i = 0; i < response.data.length; i++) {
            var employeeobject = response.data[i]
            for (var j = 0; j < employeeobject.empBusinessCoverageAreas.length; j++) {
              var empbuscovarea = employeeobject.empBusinessCoverageAreas[j]
              this.dealersList.push({
                'dealerId': empbuscovarea.id.dealerId,
                'dealerName': empbuscovarea.ddealerInfo.dealerName
              })
            }
          }
        }).catch(e => { console.log(e) })
      }
    },
    populateQuoteValues: function (quoteId, index) {
      httpdeal.get('/quote/SearchQuoteByQuoteId/' + quoteId).then(response => {
        this.quoteIdList = response.data
        this.quote = this.quoteIdList[0]
        this.getCustomerDetails(this.quote.customerId)
        // this.getFraudCustomer(this.quote.customerId)
        this.getVinFraudReason(this.quote.lmVin)
        this.getAgentDetails(this.quote.employeeId, 'SR')
        if (this.quote.creditAnalystId > 0) {
          this.getAgentDetails(this.quote.creditAnalystId, 'CA')
        }
        this.getDealerDetails(this.quote.dealerId, 'quote')
        // this.getCustomerStateDetails(this.customer.address.stateFipsC)
        this.updateDealer(this.quote.employeeId)
        this.information = ''
        this.errors.clear()
        this.$validator.reset()
      }).catch(e => {
        this.errors.push(e)
      })
    },

    colorRow: function (quoteNumber) {
      if (quoteNumber === this.selectedquote) { return 'selected-quote' } else { return 'non-selected-quote' }
    },

    fetchData () {
      this.retrieveQuoteDealerList()
      this.retrieveQuoteCustomerList()
      this.quotesSearch()
      this.retrieveCustomerList()
      this.retriveQuoteYearList()
      this.retriveQuoteMakeList()
      this.retriveQuoteModelList()
      this.retriveQuoteDealerStateList()
      this.retrieveAgentList()
      this.retriveQuoteNumbersList()
      this.retrieveStateList()
      // this.retriveQuoteEmployeeList()
    },
    retrieveStateList () {
      httpcommon.get('/statefip/').then(response => {
        this.states = response.data
      })
        .catch(e => {
          this.cuserrorslist.push(e)
        })
    },
    savecustomerdata () {
      this.customer.digitalContactInfo.mobileNumber = this.customer.digitalContactInfo.mobileNumber.replace(/[^0-9]/g, ''),
      this.customer.digitalContactInfo.workNumber = this.customer.digitalContactInfo.workNumber.replace(/[^0-9]/g, ''),
      //       this.customer = {
      // 'digitalContactInfo': {
      //  'mobileNumber': this.customer.digitalContactInfo.mobileNumber.replace(/[^0-9]/g,''),

      //           'workNumber': this.customer.digitalContactInfo.workNumber.replace(/[^0-9]/g,''),

      // },
      //       }
      this.customer.address.stateFipsC = this.selectedCustomerStateData.stateFipsC

      httpcustomer.put('/customer/', this.customer).then(response => {
        var status = response.data
        if (status == 'ACCEPTED') {
          this.customer = []
          this.quote.customerId = ''
        }
      })
        .catch(e => {
          console.log(e)
        })
    },
    savequotedata () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          if (this.fraudMobileError == '') {
        this.quote.customerId = this.selectedCustomerData.customerId
        this.quote.employeeId = this.selectedEmployeeData.employeeId
        this.quote.creditAnalystId = this.selectedCreditAnalystData.employeeId
        this.quote.dealerId = this.selectedDealerData.dealerId
        httpdeal.put('/quote/', this.quote).then(response => {
          var status = response.data
          if (status == 'ACCEPTED') {
            this.information = 'Quote Edited  Successfully'
            this.msgcolor.color = 'Blue'
            this.savecustomerdata()
            this.quotesSearch()
            this.quote = this.initializedata()
            this.selectedquote = ''
            this.continue = null
            this.vincontinue = null
          } else {
            this.msgcolor.color = 'Red'
            this.information = ''
            this.quotesSearch()
            this.resetEntries()
            this.quote = this.initializedata()
            this.selectedquote = ''
            this.continue = null
            this.vincontinue = null
          }
        })
          .catch(e => {
            this.msgcolor.color = 'Red'
            this.information = '' || e.name || e.message
            this.quotesSearch()
            this.resetEntries()
            this.quote = this.initializedata()
            this.selectedquote = ''
            this.continue = null
            this.vincontinue = null
          })
      }
        }
      })
      
    },
    // retrieveQuotes () {

    //     var frmDt,  toDt
    //     if (this.fromDate !='')
    //       frmDt=  util.formatDateMoment(moment(this.fromDate))
    //     else
    //       frmDt=this.fromDate
    //     if (this.toDate !='')
    //       toDt=  util.formatDateMoment(moment(this.toDate))
    //        else
    //       toDt=this.toDate
    //       //console.log(this.quoteStatus)
    //        httpdeal.get('/quote',

    //        ).then(response => {

    //          if (response.data.length==0){
    //             this.listQuotes =[]

    //             this.information='No Quotes available in the system'
    //              this.msgcolor.color = 'Red'

    //         }

    //         else{
    //           this.information=''
    //         this.listQuotes = response.data

    //         }
    //       })
    //       .catch(e => {
    //        console.log(e)
    //       })
    // },
    async quotesSearch () {
      this.listQuotes = []
      this.isLoading = true
      var employeeId1
      var creditAnalystId1
      var dealerId1
      var customerId1
      var stateId1
      if (this.selectedAgentId != '') {
        employeeId1 = this.selectedAgentId.employeeId
      } else {
        employeeId1 = this.selectedAgentId
      }
      if (this.selectedCreditAnalystId != '') {
        creditAnalystId1 = this.selectedCreditAnalystId.employeeId
      } else {
        creditAnalystId1 = this.selectedCreditAnalystId
      }
      if (this.selectedDealerId != '') {
        dealerId1 = this.selectedDealerId.dealerId
      } else {
        dealerId1 = this.selectedDealerId
      }
      if (this.selectedCustomerId != '') {
        customerId1 = this.selectedCustomerId.customerId
      } else {
        customerId1 = this.selectedCustomerId
      }
      if (this.selectedDealerState != '') {
        stateId1 = this.selectedDealerState.stateId
      } else {
        stateId1 = this.selectedDealerState
      }
      var frmDt, toDt
      if (this.fromDate != '') { frmDt = util.formatDateMoment(moment(this.fromDate)) } else { frmDt = this.fromDate }
      if (this.toDate != '') { toDt = util.formatDateMoment(moment(this.toDate)) } else { toDt = this.toDate }
      
      this.$validator.validateAll().then(async () => {
        if (!this.errors.any()) {
          if (this.quoteStatus === 'All') {
            this.quoteStatus = ''
          }
          const payload = {
        "quoteNumber": this.selectedQuoteNumber || "",
        "fromDate": this.fromDate || null,
        "toDate": this.toDate || null,
        // "fromDate": "2024-11-10",
        // "toDate": "2024-11-19",
        "salesRepId": this.selectedAgentId.employeeId || null,
        "dealerId": this.selectedDealerId.dealerId || null,
        "customerId": this.selectedCustomerId.customerId || null,
        "dealerState": this.selectedDealerState.stateFipsC || "",
        "make": this.quoteMake || "",
        "year": this.quoteYear || null,
        "model": this.quoteModel || "",
        "quoteStatus": this.quoteStatus || "",
        "creditAnalystId": this.selectedCreditAnalystId.employeeId || null
        }
      await httpdeal.post('/quote/SearchQuote', payload, {params: {'page' : this.currentPage -1, 'size': 10}}).then(async response => {
        if (response.data.content.length == 0) {
              this.listQuotes = []
              this.information = 'No Quotes available in the system with the provided search criteria'
              this.msgcolor.color = 'Red'
              if (this.quoteStatus == '') {
                this.quoteStatus = 'All'
              }
              this.quote = this.initializedata()
            } else {
              this.information = ''
              var arr = []
              var j = 0
              var fraudreason = []
              var listApps1 = []
              listApps1 = response.data.content

              for (var i = 0; i < listApps1.length; i++) {
                arr.push(listApps1[i].customerId)
                // listApps1[i]['dealerFraudreason'] = listApps1[i].lmDealerName != null ? await this.getFraudDealerReason(listApps1[i].lmDealerName) : null
              }
              await httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + arr).then(response => {
                fraudreason = response.data
                for (j = 0; j < listApps1.length; j++) {
                  for (var k = 0; k < fraudreason.length; k++) {
                    if (listApps1[j].customerId == fraudreason[k].customerId) {
                      if (fraudreason[k].customerFraudReason != '') { listApps1[j]['fraudreason'] = fraudreason[k].customerFraudReason } else { listApps1[j]['fraudreason'] = null }
                    }
                  }
                }
                this.listQuotes = listApps1
              })
              
              this.totalPages =  response.data.totalPages
              this.numberOfElements = response.data.numberOfElements;
              this.totalElements = response.data.totalElements
              if (this.quoteStatus == '') {
                this.quoteStatus = 'All'
              }
              this.quote = this.initializedata()
              this.selectedquote = ''
            }
            this.isLoading = false
          })
            .catch(e => {
              console.log(e)
              this.isLoading = false
            })
        }
            })
    },

    async getFraudDealerReason (dealer) {
      const dealerData = {
        dealerName: dealer
      }
      try {
        const response = await httpsource.post('/fraudDealerDetails', dealerData)
        if (response.data.length > 0) {
          return response.data[0].dealerFlagReason
        } else {
          return null // Return null if no data is found
        }
      } catch (e) {
        console.log(e)
        return null // Return null if there's an error
      }
    },

    enableSubmit () {
      if (this.quote.overrideFraud != null && this.quote.overrideFraud.length > 0) {
        this.enablebutton = false
      } else { this.enablebutton = true }
    },

    resetEntries () {
      this.selectedDealerId = ''
      this.selectedCustomerId = ''
      this.fromDate = moment().subtract(60, 'days').format('YYYY-MM-DD')
      this.toDate = moment().format('YYYY-MM-DD')
      this.quoteYear = ''
      this.quoteMake = ''
      this.quoteModel = ''
      this.quoteStatus = 'All'
      this.selectedAgentId = ''
      this.selectedCreditAnalystId = ''
      this.selectedQuoteNumber = ''
      this.customerFraudReason = null
      this.searchDealerFraudReason = null
      this.information = ''
      this.quoteMessage = ''
      this.selectedquote = ''
      this.quoteSearch = ''
      this.selectedDealerState = ''
      this.currentPage = 1;
      this.quote = this.initializedata()
      this.quotesSearch()
      this.$validator.reset()
    },
    initializedata () {
      return {
        lmQuoteId: '',
        leaseType: '',
        dealerName: '',
        inHouseName: '',
        quoteDate: new Date(),
        proposedLessee: '',
        terms: '',
        salesAgent: '',
        make: '',
        model: '',
        year: '',
        currentMiles: '',
        vin: '',
        overrideFraud: null,
        LesseeFraudReason: '',
        approvalNote: '',
        selectedCustomerId: '',
        selectedEmployeeId: '',
        vinFraudReason: null,
        dealerID: '',
        initialEquityTarget: '',
        exitEquityTarget: '',
        initialWholeSaleValue: '',
        exitWholeSaleValue: '',
        advancePayments: '',
        remainingPayments: '',
        loanFundingCost: '',
        leaseFundingCost: '',
        state: '',
        stateTaxRate: '',
        countyTaxRate: '',
        zipTaxRate: '',
        netPayDealer: '',
        payDealerDMVFees: '',
        TXTaxpaidByDealer: '',
        isTradeTaxExcempt: '',
        firstACHDate: '',
        lastACHDate: '',
        vehiclePrice: '',
        dealerTxnFee: '',
        totalPrice: '',
        cashCapReduction: '',
        tradeValue: '',
        tradePayoff: '',
        tradeCredit: '',
        totalCapReduction: '',
        leaseCapCost: '',
        llpInitialResidual: '',
        llpResidualAdjustment: '',
        llpFinalResidual: '',
        residualRevenue: '',
        leaseResidual: '',
        initialPreTaxLeasePayment: '',
        adjToMonthlyLeasePayment: '',
        finalPreTaxMonthlyLeasePayment: '',
        taxOnMonthlyTaxLeasePayment: '',
        finalMonthlyLeasePayment: '',
        upfrontLeasePaymentDue: '',
        totalCapCostReduction: '',
        taxDueAtInception: '',
        acquisitionFee: '',
        serviceContractFee: '',
        taxOnFees: '',
        dealerFee: '',
        estDMVFee: '',
        securityDeposit: '',
        other: '',
        totalDueUponSigning: '',
        lessTradeCredit: '',
        lessDealerDeposit: '',
        cashDueUponSigning: '',
        sumOfLeasePayments: '',
        depreciation: '',
        sumOfPreTaxLeasePayments: '',
        totalRentalCharge: '',
        taxOnInitialLeasePayments: '',
        monthlyDepreciation: '',

        loanAmount: '',
        loanPaymentEst: '',
        originationRevenue: '',
        originationReserve: '',
        originationIncome: '',
        annuityRevenueMonthly: '',
        annuityReserveMonthly: '',
        annuityIncomeMonthly: '',
        annuityRevenueLifeOfLease: '',
        annuityReserveLifeOfLease: '',
        annuityIncomeLifeOfLease: '',
        totalRevenueLifeOfLease: '',
        totalReserveLifeOfLease: '',
        totalIncomeLifeOfLease: '',
        taxDueOnCashCapRed: '',
        taxDueOnPmtsCapCost: '',
        taxOnTrade: '',

        paymentsData: [
          {
            amortest: 90,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 100,
            valuationcommentary: ''
          },
          {
            amortest: 19,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 23,
            valuationcommentary: ''
          },
          {
            amortest: 200,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 222,
            valuationcommentary: ''
          },
          {
            amortest: 990,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 999,
            valuationcommentary: ''
          },
          {
            amortest: 179,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 333,
            valuationcommentary: ''
          },
          {
            amortest: 99,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 100,
            valuationcommentary: ''

          }

        ],
        totalValue: '',
        totalamortest: '',
        totalequity: '',
        totalpercentEquity: '',
        cashDueAtSigning: '',
        fullAmortizationList: ''

      }
    }

  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
    this.fromDate = moment().subtract(60, 'days').format('YYYY-MM-DD')
    this.toDate = moment().format('YYYY-MM-DD')
  },

  computed: {
    sortedLesseeNames: function () {
      return this.quoteCustomersList.sort((a, b) => {
        var obj1Name, obj2Name
        if (a.customerType == 'P') {
          if (a.middleName != null && a.middleName.length != 0) {
            obj1Name = a.firstName + ',' + a.middleName
            if (a.lastName != null && a.lastName.length != 0) {
              obj1Name += a.lastName
            }
          } else {
            if (a.lastName != null && a.lastName.length != 0) {
              obj1Name = a.firstName + a.lastName
            } else {
              obj1Name = a.firstName
            }
          }
        } else if (a.customerType == 'B') {
          obj1Name = a.businessName
        }
        if (b.customerType == 'P') {
          if (b.middleName != null && b.middleName.length != 0) {
            obj2Name = b.firstName + ',' + b.middleName
            if (b.lastName != null && b.lastName.length != 0) {
              obj2Name += b.lastName
            }
          } else {
            if (b.lastName != null && b.lastName.length != 0) {
              obj2Name = b.firstName + b.lastName
            } else {
              obj2Name = b.firstName
            }
          }
        } else if (b.customerType == 'B') {
          obj2Name = b.businessName
        }
        if (obj1Name != null && obj2Name != null) {
          if (obj1Name.toLowerCase() < obj2Name.toLowerCase()) { return -1 }
          if (obj1Name.toLowerCase() > obj2Name.toLowerCase()) { return 1 }
        }
        return 0
      })
    },
    sortedCustomerNames: function () {
      return this.customersList.sort((a, b) => {
        var obj1Name, obj2Name
        if (a.customerType == 'P') {
          if (a.middleName != null && a.middleName.length != 0) {
            obj1Name = a.firstName + ',' + a.middleName
            if (a.lastName != null && a.lastName.length != 0) {
              obj1Name += a.lastName
            }
          } else {
            if (a.lastName != null && a.lastName.length != 0) {
              obj1Name = a.firstName + a.lastName
            } else {
              obj1Name = a.firstName
            }
          }
        } else if (a.customerType == 'B') {
          obj1Name = a.businessName
        }
        if (b.customerType == 'P') {
          if (b.middleName != null && b.middleName.length != 0) {
            obj2Name = b.firstName + ',' + b.middleName
            if (b.lastName != null && b.lastName.length != 0) {
              obj2Name += b.lastName
            }
          } else {
            if (b.lastName != null && b.lastName.length != 0) {
              obj2Name = b.firstName + b.lastName
            } else {
              obj2Name = b.firstName
            }
          }
        } else if (b.customerType == 'B') {
          obj2Name = b.businessName
        }
        if (obj1Name != null && obj2Name != null) {
          if (obj1Name.toLowerCase() < obj2Name.toLowerCase()) { return -1 }
          if (obj1Name.toLowerCase() > obj2Name.toLowerCase()) { return 1 }
        }
        return 0
      })
    },

    dateRange: function () {
      let date1 = new Date(this.fromDate)
      let date2 = new Date(this.toDate)
      let yearsDiff = date2.getFullYear() - date1.getFullYear()
      let months = (yearsDiff * 12) + (date2.getMonth() - date1.getMonth())
      if (this.fromDate != '' && this.toDate != '' && this.fromDate === this.toDate) {
        this.msgcolor.color = 'Red'
        return 'From date should be Less than to date'
      }
      if (this.fromDate != '' && months > 5) {
        this.msgcolor.color = 'Red'
        return 'Allowed Maximum Date Range is 6 Months'
      } else { return '' }
    },

    sortedDealers: function () {
      return this.dealersList.sort((a, b) => { return a.dealerName > b.dealerName ? 1 : -1 })
    },
    customerType: function () {
      var custSelect = this.quote.customerId
      var custType = ''
      if (this.quote.customerId != -1) {
        this.customersList.forEach(customerObj => {
          if (customerObj.customerId == custSelect) {
            custType = customerObj.customerType
          }
        })
      }
      return custType
    }

  },
  filters: {
    formatCustType (customerType) {
      if (customerType == '') {
        return 'Personal/Business'
      } else if (customerType == 'B') {
        return 'Business'
      } else if (customerType == 'P') {
        return 'Personal'
      }
    }
  }
}
</script>
<style scoped>
.selected-quote {
  background: lightsalmon;
}

.non-selected-quote {
  background: lightgray;
}

.submitButton {
  width: 80px;
}

.required:after {
  content: " *";
}

.wrap-text {
  white-space: nowrap;
}

.nextButton {
  margin: 0px;
  padding: 0px;
  border-radius: 6px;
  font-size: 10px;
  height: 30px;
  width: 100px;
}

thead {
  position: sticky;
  top: 0px;
  /* 0px if you don't have a navbar, but something is required */

}
.hide-scrollbars {
    overflow: hidden !important;
  } 
</style>
